/**
 * Author : zhengyanfeng.
 * Date   : 2021/1/5.
 * File   : province. 城市id对象
 */
export default {
  '350121': {
    position: {
      left: '750px',
      top: '190px'
    },
    background: '/static/mapPoint/mapPicture/fujian/fuzhou/minhou.png',
    diningList: [
      {
        departmentName: '福州大学',
        departmentId: 'D8FEAC80658A74DE9A1BA23174E9A7F99',
        position: {
          left: '110px',
          top: '205px'
        },
        active: '01'
      },
      {
        departmentName: '技师学院',
        departmentId: 'D79389791D5BB403F995E90E4761DD45B',
        position: {
          left: '65px',
          top: '100px'
        },
        active: '01'
      },
      {
        departmentName: '工程学院',
        departmentId: 'D729EB574F8A34378BCCDC6CCBA74DECC',
        position: {
          left: '140px',
          top: '300px'
        },
        active: '01'
      },
      /*{
        departmentName: '闽江学院',
        departmentId: 'D1835071AD7CA4072A85F23A85C27A877',
        position: {
          left: '15px',
          top: '190px'
        },
        active: '01'
      },*/
      {
        departmentName: '中鸿达',
        departmentId: 'D1835071AD7CA4072A85F23A85C27A877',
        position: {
          left: '210px',
          top: '330px'
        },
        active: '01'
      },
      {
        departmentName: '第二食堂',
        departmentId: 'D35E48B188ED041108C1E9F3E7A20855C',
        position: {
          left: '35px',
          top: '30px'
        },
        active: '01'
      },
      {
        departmentName: '第三食堂',
        departmentId: 'D70CD7C9FE4244CCA91DD9E059441E531',
        position: {
          left: '80px',
          top: '80px'
        },
        active: '01'
      }
    ]
  },
  '350182': {
    position: {
      left: '1034px',
      top: '458px'
    },
    background: '/static/mapPoint/mapPicture/fujian/fuzhou/changle.png',
    diningList: [
      {
        departmentName: '辅布司',
        departmentId: 'DAF03EE59B312417092CB9EFAB88DB689',
        position: {
          left: '100px',
          top: '40px'
        },
        active: '01'
      }
    ]
  },
  '350104': {
    position: {
      left: '936px',
      top: '440px'
    },
    background: '/static/mapPoint/mapPicture/fujian/fuzhou/cangshan.png',
    diningList: [
      {
        departmentName: '邮校第一食堂',
        departmentId: 'D18CA078186694D1D84AE02353709E50D',
        position: {
          left: '35px',
          top: '5px'
        },
        active: '01'
      },
      {
        departmentName: '邮电第一食堂',
        departmentId: 'DC82EE4700F7A4EBA803D9EE0BF429E4E',
        position: {
          left: '25px',
          top: '-40px'
        },
        active: '01'
      }
    ]
  },
  '350105': {
    position: {
      left: '1014px',
      top: '414px'
    },
    background: '/static/mapPoint/mapPicture/fujian/fuzhou/mawei.png',
    diningList: [
      {
        departmentName: '阳光学院',
        departmentId: 'D2D1BBEE26736424188D8F31B50C62E83',
        position: {
          left: '55px',
          top: '-15px'
        },
        active: '01'
      }
    ]
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/mapPoint/diningPoint/fujian/fuzhou.js
// module id = null
// module chunks = 